import React from 'react'
import { isEmpty, omit } from 'lodash'
import { checkEmail } from '../../../containers/Signin'
import { makePDF } from '../../../helpers/getPDF'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers, withState, withProps, lifecycle } from 'recompose'
import { injectIntl, FormattedMessage } from 'react-intl'
import { fetchingState } from './../../../helpers/hocs.js'
import { getIsLogged } from '../../../selectors/user.js'
import { uploadImageForm, sendApprovalForm } from '../../../store/reducers/profile/personApprovalForm' 
import md5 from 'blueimp-md5'
import { pick } from 'lodash'
import Form from './../../Form'
import Loader from '../../OverlayLoader'
import { getUser } from '../../../store/reducers/auth.js'


const ApprovalForm = ({ showSendButton, checkState, setCheckState, showCompleteMessage, showForm, photoProfile, sendAgree, sendData, sendNoAgree, isLogged, images, data, upload, imagesState, errors, createPDF, setDataHandler, imageRemove, fetching, intl, setMode, person}) => {
  return (!isLogged || !person || !data) ? null : (
  <div className='modal_edit'>
    {showForm && 
      <div className='modal__field modal__field_profile'>
        {!showSendButton &&<div className='approval-form-body'>
          <div className='approval-form-item'>
            <div className='approval-form-itemTitle'>Фамилия:</div>
            <Form value={data.surname} placeholder={intl.formatMessage({id: 'profile_edit.surname'})} onInput={setDataHandler('surname')} 
            classname="Form__field Form__field-settings" disableBtn noEnter noAutoFocus />
            {errors.surname && <div className='Text'>{errors.surname}</div>}
          </div>
          <div className='approval-form-item'>
            <div className='approval-form-itemTitle'>Имя:</div>
            <Form value={data.name} placeholder={intl.formatMessage({id: 'profile_edit.name'})} onInput={setDataHandler('name')} 
            classname="Form__field Form__field-settings" disableBtn noEnter noAutoFocus />
            {errors.name && <div className='Text'>{errors.name}</div>}
          </div>
          <div className='approval-form-item'>
            <div className='approval-form-itemTitle'>Отчество:</div>
            <Form value={data.middlename} placeholder={intl.formatMessage({id: 'profile_edit.middlename'})} onInput={setDataHandler('middlename')} 
            classname="Form__field Form__field-settings" disableBtn noEnter noAutoFocus />
            {errors.middlename && <div className='Text'>{errors.middlename}</div>}
          </div>
          <div className='approval-form-item'>
            <div className='approval-form-itemTitle'>Телефон:</div>
            <Form value={data.phone} classname="Form__field Form__field-settings" onInput={setDataHandler('phone')} disableBtn noEnter noAutoFocus />
            {errors.phone && <div className='Text'>{errors.phone}</div>}
          </div>
          <div className='approval-form-item'>
            <div className='approval-form-itemTitle'>Email:</div>
            <Form value={data.email} classname="Form__field Form__field-settings" onInput={setDataHandler('email')} disableBtn noEnter noAutoFocus />
            {errors.email && <div className='Text'>{errors.email}</div>}
          </div>
          <div className='approval-form-item'>
            <div className="Form__field EmailPopup__bigText Form__field-settings  approval-form-itemTitle approval-passportData"><FormattedMessage id='profile_edit.passport'/></div>
            <div className="Form__field Form__field-settings-birthdayForm passport-data">
              <div className="Form__field Form__field-settings passport-data__series">
                <Form value={data.passportseries} placeholder={intl.formatMessage({id: 'person_profile.passport_series'})} onInput={setDataHandler('passportseries')} 
                classname="Form__field Form__field-settings" type="Number" disableBtn noEnter noAutoFocus min='4' />
              </div>
              <div className="Form__field Form__field-settings passport-data__number">
                <Form value={data.passportnumber} placeholder={intl.formatMessage({id: 'person_profile.passport_number'})} onInput={setDataHandler('passportnumber')} 
                classname="Form__field Form__field-settings" type="Number" disableBtn noEnter noAutoFocus min='6' />
              </div>
              {(errors.passportseries || errors.passportnumber) && <div className='Text passport-data__error'>{errors.passportseries || errors.passportnumber}</div>}
            </div>
          </div>
          <div className='approval-form-item'>
          <div className='approval-form-itemTitle'>Выдан:</div>
            <Form value={data.passport_organization} placeholder={intl.formatMessage({id: 'person_profile.passport_organization'})} onInput={setDataHandler('passport_organization')} 
            classname="Form__field Form__field-settings" disableBtn noEnter noAutoFocus />
            {errors.passport_organization && <div className='Text'>{errors.passport_organization}</div>}
          </div>
        </div>}
        <br /><br /><br />
        {!showSendButton && <button type='submit' style={{ marginBottom: 12 }} className='Button Button_white' onClick={createPDF}><FormattedMessage id='person_data_form.create' /></button>}
        &nbsp;&nbsp;&nbsp;
        {!showSendButton 
          ?
          <label className='Button Button_white downloadApprovalForm'>
            <input className='modal__photos-field' type='file' accept='.jpg, .jpeg, .png' multiple onChange={upload} disabled={Object.keys(imagesState).length === 1 ? true : false}/>
            Загрузить форму
          </label>
          :
          <div>
            <div className='approval-form-offer'>
              <input type='checkbox'  name='offerCheckbox' checked={checkState} onChange={() => setCheckState(!checkState)} />
              <a className="approval-link" href="/assets/files/docs/approvalfoto.docx" target="_blank">
                Нажимая на кнопку «Отправить», я, в соответствии со статьей 152.1 Гражданского Кодекса Российской Федерации, даю свое согласие на использование моих изображений
              </a>
            </div>
            {errors.offer && <div>Необходимо согласиться с условиями</div>}
            <button className='Button Button_white' onClick={sendData}>
              Отправить
            </button>
          </div>
          }    
        <div className='modal__photos-preview'>
            {Object.keys(imagesState).map(key => (
              <div className='modal__photos-preview-item' key={key}>
                {(imagesState[key] < 100 ||  !images || !images[key])
                  ? 
                  <Loader isLight />
                  :
                  (<div className='modal__photos-preview-img'>
                      <img src={images[key].url} alt={images[key].name} className='approvalForm-img' />
                      <span className='modal__photos-preview-overlay Text' onClick={imageRemove.bind(this, key)}>
                          <span className='modal__photos-preview-overlay__after'>
                            {intl.formatMessage({id: 'profile_report.delete_approval_form'})}
                          </span>
                      </span>
                  </div>)
                }
              </div>
            ))}
        </div>
      </div>
    }
    {!showForm && 
      <div className='take_agree'>
        <div className='approval-form-item'>
          <div className='approval-form-itemTitle'>Комментарий:</div>
          <Form
            value={data.comment} classname="Form__field Form__field-settings"
            onInput={setDataHandler('comment')}
            placeholder={intl.formatMessage({id: 'person_data_form.not_agree_comment'})} 
            disableBtn noEnter noAutoFocus 
          />
          {errors.comment && <div className='Text'>{errors.comment}</div>}
        </div>
        <button type='submit' style={{ marginBottom: 12 }} className='Button Button_white'
          onClick={sendNoAgree}
        >
          <FormattedMessage id='person_data_form.not_agree' />
        </button>
        &nbsp;&nbsp;&nbsp;
        <button type='submit' style={{ marginBottom: 12 }} 
          className='Button Button_white'
          onClick={sendAgree}
        >
          <FormattedMessage id='person_data_form.agree' />
        </button>
        {errors.images && <div className='Text'>Загрузите форму согласия</div>}
      </div>}
  </div>
)}

const mapStateToProps = state => ({
  isLogged: getIsLogged(state),
  ...state.profile.personApprovalForm,//состояние для загрузки формы на печать
})

const mapDispatchToProps = dispatch => bindActionCreators({ uploadImageForm, sendApprovalForm, getUser }, dispatch)

export default injectIntl(compose(
  fetchingState(),
  connect(mapStateToProps, mapDispatchToProps),
  withState('mode', 'setMode', 'edit','editEmail'),
  withState('checkState', 'setCheckState', false),
  withState('imagesState', 'setImages', {}),
  withState('showForm', 'setShowForm', false),
  withState('showSendButton', 'setShowSendButton', false),

  withHandlers({
    setMode: ({ setMode }) => mode => e => {
      e && e.preventDefault()
      setMode(mode)
    },
  }),
  withState('data', 'setData', {}),
  withState('errors', 'setErrors', {}),
  
  withProps(props => {
      let data = {
        ...props.person,
        surname: props.person.descriptions[0].lastname || null,
        name: props.person.descriptions[0].firstname || null,
        middlename: props.person.descriptions[0].middlename || null,
        ...props.data
      }
    return ({ data })
  }),
  withHandlers({
    setDataHandler: ({ setData, data }) => field => value => {
      if (field === 'passportseries' && value.length > 4) return
      if (field === 'passportnumber' && value.length > 6) return
      data[field] = value
      setData(data)
    },
    createPDF: ({data, photoProfile, intl, setErrors}) => async e => {
      //формирование pdf-формы согласия для печати
      e && e.preventDefault()
      let errors = {}

      if (!data.name) errors.name = intl.formatMessage({id: 'profile_edit.field_required'})
      if (!data.surname) errors.surname = intl.formatMessage({id: 'profile_edit.field_required'})
      if (!data.middlename) errors.middlename = intl.formatMessage({id: 'profile_edit.field_required'})
      if (!data.email || !checkEmail(data.email)) errors.email = intl.formatMessage({id: 'profile_edit.field_required'})
      if (!data.phone) errors.phone = intl.formatMessage({id: 'profile_edit.field_required'})
      if (!data.passportseries || data.passportseries.length !== 4) errors.passportseries = intl.formatMessage({id: 'profile_edit.field_required'})
      if (!data.passportnumber || data.passportnumber.length !== 6) errors.passportnumber = intl.formatMessage({id: 'profile_edit.field_required'})
      if (!data.passport_organization) errors.passport_organization = intl.formatMessage({id: 'profile_edit.field_required'})
      data.photo = photoProfile

      setErrors(errors)
      if (!isEmpty(errors)) return
      await makePDF(data)
    },
    upload: ({ setImages, uploadImageForm, imagesState, images, setErrors, setShowSendButton }) => async e => {
      const files = e.target.files

      try{
        for (let i = 0; i < files.length; i++) { // images
          const file = files.item(i)
  
          imagesState[md5(file.name)] = 0
          setImages(imagesState)
  
          const onUpload = (e) => {
            imagesState[md5(file.name)] = Math.floor((e.loaded * 100) / e.total)
            setImages(imagesState)
          }
          const imageData = await uploadImageForm(file, onUpload)
          if (imageData === 200) setShowSendButton(true)
        }
      }catch(err){
        alert(err)
      }
    },
    sendAgree: ({setShowForm}) => async e => {
      e && e.preventDefault()
      setShowForm(true)
    },
    sendData: ({images, getUser, setShowForm, showCompleteMessage, imagesState, setErrors, sendApprovalForm, setImages, setShowSendButton, checkState, setCheckState}) => async e => {
      e && e.preventDefault()
      const agreeData = {}
      if (Object.values(images).length > 0) {
        //images = Object.keys(imagesState)
        images = Object.values(pick(images, Object.keys(imagesState))).map(el => el._id)
        agreeData.approvalFormId = images[0];
      } 
      let errors = {};
      if (!agreeData.approvalFormId)  errors.images = true
      if (!checkState) errors.offer = true
      setErrors(errors)
      if (Object.keys(errors).length === 0) {
        agreeData.agree = true
        agreeData.description = 'Пользователь согласен с условиями'
        let result = await sendApprovalForm(agreeData);
        if (result === 200) {
          await getUser()
          if (Object.keys(imagesState).length) setImages({})
          setErrors({})
          showCompleteMessage(true)
          setShowSendButton(false)
          setShowForm(false)
          setTimeout(() => showCompleteMessage(false), 1500)
        }
      }
    },
    sendNoAgree: ({data, showCompleteMessage, setErrors, intl, sendApprovalForm}) => async e => {
      e && e.preventDefault()
      let errors = {};
      if (!data.comment) errors.comment = intl.formatMessage({id: 'profile_edit.field_required'})
      setErrors(errors)
      if (Object.keys(errors).length === 0) {
        const noAgreeData = {
          description: 'Пользователь не согласен с условиями',
          agree: false,
          comment: data.comment
        }
        let result = await sendApprovalForm(noAgreeData);
        if (result === 200) {
          showCompleteMessage(true)
          setTimeout(() => showCompleteMessage(false), 1500)
        }
      }
    },
    imageRemove: ({ setImages, imagesState, setShowSendButton }) => (key, e) => {
      e && e.preventDefault()
      setImages(omit(imagesState, key))
      setShowSendButton(false)
    },
  }),
  lifecycle({
    componentDidMount() {
      if (this.props.imagesState && Object.keys(this.props.imagesState).length > 0) this.props.setShowSendButton(true)
    }
  })
)(ApprovalForm))


// WEBPACK FOOTER //
// ./src/components/PersonProfile/Form/ApprovalForm.jsx